const firebaseConfig = {
    apiKey: "AIzaSyA6GPOLMEMaNXbgFD-BDFOklLORKaBoGVE",
    authDomain: "travel-guru-aa.firebaseapp.com",
    databaseURL: "https://travel-guru-aa.firebaseio.com",
    projectId: "travel-guru-aa",
    storageBucket: "travel-guru-aa.appspot.com",
    messagingSenderId: "246451434793",
    appId: "1:246451434793:web:869d4ef5ee22dc2ddb7338"
  };
export default firebaseConfig;